import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix para os ícones do Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const Map = ({ tablets }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    if (!mapInstanceRef.current) {
      // Criar o mapa centrado no Brasil (Caucaia, CE)
      mapInstanceRef.current = L.map(mapRef.current).setView([-3.7365, -38.6531], 12);

      // Adicionar tile layer (OpenStreetMap)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors',
        maxZoom: 19,
      }).addTo(mapInstanceRef.current);
    }

    // Limpar marcadores anteriores
    markersRef.current.forEach(marker => marker.remove());
    markersRef.current = [];

    // Adicionar novos marcadores
    const tabletsWithCoords = tablets.filter(
      t => t.coordinates?.latitude && t.coordinates?.longitude
    );

    tabletsWithCoords.forEach(tablet => {
      const icon = L.divIcon({
        className: 'custom-marker',
        html: `<div class="marker-pin ${tablet.status}">
          <div class="marker-dot"></div>
        </div>`,
        iconSize: [30, 42],
        iconAnchor: [15, 42],
        popupAnchor: [0, -42]
      });

      const marker = L.marker(
        [tablet.coordinates.latitude, tablet.coordinates.longitude],
        { icon }
      ).addTo(mapInstanceRef.current);

      marker.bindPopup(`
        <div class="marker-popup">
          <strong>${tablet.name}</strong><br/>
          <span class="popup-status ${tablet.status}">
            ${tablet.status === 'online' ? '🟢 Online' : '🔴 Offline'}
          </span><br/>
          ${tablet.location ? `📍 ${tablet.location}` : ''}
        </div>
      `);

      markersRef.current.push(marker);
    });

    // Ajustar visualização se houver marcadores
    if (tabletsWithCoords.length > 0) {
      const bounds = L.latLngBounds(
        tabletsWithCoords.map(t => [t.coordinates.latitude, t.coordinates.longitude])
      );
      mapInstanceRef.current.fitBounds(bounds, { padding: [50, 50] });
    }

  }, [tablets]);

  return <div ref={mapRef} style={{ width: '100%', height: '100%', borderRadius: '8px' }} />;
};

export default Map;
